import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';

const SectionCard4 = () => {
    const { t } = useLang('theProduct.SectionCard4');

    return (
        <div
            className={`${styles.SectionCard4} SectionCard4 GtmModuleData-section`}
            id="SectionCard4"
            data-section-id={styles.SectionCard4}
            data-section-title={t('title')}
        >
            <EcoSpace />
            <EcoSectionCommon
                title={t('title')}
                desc={t('desc')}
                lChildren={t('btn')}
                lHref={`https://time.com/collections/best-inventions-2025/7318344/ecoflow-ocean-pro-home-battery-storage/`}
                lDataLayer={{
                    __btn_id1: styles.SectionCard4,
                    __btn_id2: `https://time.com/collections/best-inventions-2025/7318344/ecoflow-ocean-pro-home-battery-storage/`,
                }}
            />
            <div className="content">
                <EcoImg
                    className="banner"
                    pc="https://websiteoss.ecoflow.com/upload/image/1760670801268/SectionCard4-pc.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1760670801155/SectionCard4-h5.jpg"
                />
            </div>
        </div>
    );
};

export default SectionCard4;
